<template>
  <div>
    <div class="header">
      <a-form class="form" :form="form" layout="inline">
        <a-form-item label="城市名称">
          <a-input allowClear style="width: 200px;" v-decorator="['city']" />
        </a-form-item>
        <a-form-item label="所属国家">
          <a-select
            showSearch
            allowClear
            optionFilterProp="children"
            style="width: 200px;"
            v-decorator="['country']"
            :options="countries"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="onFormSubmit">查询</a-button>
        </a-form-item>
      </a-form>
      <a-button @click="onCreate">新增城市</a-button>
    </div>
    <a-table
      rowKey="id"
      :columns="columns"
      :dataSource="list"
      :pagination="paging"
      @change="onTableChange"
    >
      <template slot="actions" slot-scope="_, record">
        <a-button type="primary" class="mgr_10" @click="onEdit(record.id)">编辑</a-button>
        <a-button type="danger" @click="onRemove(record.id)">删除</a-button>
      </template>
    </a-table>
    <city-modal
      :id="cityId"
      :visible="modalVisible"
      @confirm="onModalConfirm"
      @cancel="modalVisible = false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import * as apis from '@/apis';
import CityModal from '@/components/CityModal';

const pageSize = 20;

export default {
  components: {
    CityModal,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      columns: [
        {
          title: '城市ID',
          dataIndex: 'id',
          // sorter: true,
        },
        {
          title: '城市名称',
          dataIndex: 'city',
        },
        {
          title: '所属国家',
          dataIndex: 'countryName',
        },
        {
          title: '添加日期',
          dataIndex: 'createdAt',
          // sorter: true,
          customRender: time => moment(time).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          title: '操作',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' },
        },
      ],
      list: [],
      paging: {},
      modalVisible: false,
      cityId: 0,
      countries: [],
    };
  },
  mounted() {
    this.loadCountries();
    this.load();
  },
  methods: {
    async load(query) {
      const result = await apis.getCities({
        limit: pageSize,
        offset: 0,
        ...query,
      });
      const { offset, limit, total } = result.pagination;

      this.list = result.data;
      this.paging = { current: offset / limit + 1, pageSize: limit, total };
    },

    async loadCountries() {
      const result = await apis.getCountries();
      this.countries = result.data.map(i => ({ key: i.id, label: i.name }));
    },

    onFormSubmit() {
      const values = this.form.getFieldsValue();
      this.load(values);
    },

    onRemove(id) {
      this.$confirm({
        title: '确认删除？',
        okText: '确认',
        cancelText: '取消',
        onOk: async () => {
          await apis.delCity(id);
          this.$emit('删除成功');
          this.load();
        },
      });
    },

    onTableChange(paging) {
      this.load({ offset: (paging.current - 1) * pageSize });
    },

    onCreate() {
      this.cityId = 0;
      this.modalVisible = true;
    },

    onEdit(id) {
      this.cityId = id;
      this.modalVisible = true;
    },

    onModalConfirm() {
      this.modalVisible = false;
      this.load();
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  margin-bottom: 12px;
  display: flex;

  .form {
    margin-right: auto;
  }
}
</style>
